import { lazy } from 'react';
import { PATHS } from './paths';

export const Vendor = lazy(() => import('./vendor'));
export const Vouchers = lazy(() => import('./vouchers'));
export const Orders = lazy(() => import('./orders'));
export const Reporting = lazy(() => import('./reporting'));
export const Authorization = lazy(() => import('./authorization'));
export const Products = lazy(() => import('./products'));
export const Settings = lazy(() => import('./settings'));
export const Menu = lazy(() => import('./menu'));

export const routes = [
  { path: PATHS.REPORTING.LIST, component: Reporting, permissions: ['reporting:access'] },
  { path: PATHS.VENDOR.LIST, component: Vendor, permissions: [] },
  { path: PATHS.VOUCHERS.LIST, component: Vouchers, permissions: ['voucher:view'] },
  { path: PATHS.ORDERS.LIST, component: Orders, permissions: ['order:view'] },
  { path: PATHS.SETTINGS.LIST, component: Settings, permissions: ['settings:view'] },
  { path: PATHS.PRODUCTS.LIST, component: Products, permissions: ['products:view'] },
  { path: PATHS.MENU.LIST, component: Menu, permissions: ['menu:view'] },
  {
    path: PATHS.AUTHORIZATION.LIST,
    component: Authorization,
    breadcrumb: 'Authorization',
    permissions: ['authorization:view'],
  },
];
